import { Model } from 'pinia-orm'

import { Attr, BelongsTo, HasMany, Num, Uid } from 'pinia-orm/dist/decorators'
import { Compartment } from 'modules/Compartment/Compartment'
import { Device } from 'modules/Device/Device'
import { Transaction } from 'modules/Transaction/Transaction'
import { Tank } from 'modules/Tank/Tank'
import { Tenant } from 'modules/Tenant/Tenant'
import { Org } from 'modules/Org/Org'

export class Fluid extends Model {
  static override entity = 'fluids'

  @Uid() declare id: string
  @Num(null) declare int_id: number | null

  @Attr(null) declare name: string
  @Attr(null) declare description: string | null
  @Attr(null) declare color: string | null
  @Attr(false) declare is_global: boolean

  @HasMany(() => Compartment, 'compartment_id') declare compartment: Compartment[]
  @HasMany(() => Device, 'device_id') declare device: Device[]
  @HasMany(() => Transaction, 'transaction_id') declare transaction: Transaction[]
  @HasMany(() => Tank, 'tank_id') declare tank: Tank[]
  @HasMany(() => Tenant, 'default_tenant_id') declare tenants_as_default: Tenant[]

  @Attr(null) declare tenant_id: string
  // @Attr(null) declare org_id: number
  @BelongsTo(() => Tenant, 'tenant_id') declare tenant: Tenant | null
  // @BelongsTo(() => Org, 'org_id') declare org: Org | null
}
